import * as $ from 'jquery';

export default {
    mounted: function() {
        this.resizeContent();

        window.addEventListener('resize', () => {
            this.resizeContent();
        });
    },
    methods: {
        resizeContent: () => {
            let header = document.querySelector('header.main');
            let footer = document.querySelector('footer.main');
            let content = document.querySelector('section .content:not(.v-center)');
            let scroll = document.querySelector('section .content:not(.v-center) .scroll');
            let height = window.innerHeight;

            if (content !== null) {
                if (header !== null) {
                    height -= header.offsetHeight;
                }

                if (footer !== null) {
                    height -= footer.offsetHeight;

                    content.style.marginBottom = footer.offsetHeight+'px';
                }

                content.style.height = height+'px';

                if (scroll !== null) {
                    scroll.style.height = height+'px';
                }
            }
        }
    }
}
